// import React from "react";
// import { Link } from "react-router-dom";

// const Thanks = () => {
//     return (
//         <div className='flex items-center justify-center h-screen'>
//             <div className='text-center'>
//                 <h1 className='text-4xl font-bold mb-4'>Thank You!</h1>
//                 <p className='text-lg mb-8'>Your order has been successfully booked.</p>

//                 <Link
//                     to='/OrderHistory'
//                     className='mt-16 bg-red-500 text-white py-2 px-4 rounded'
//                 >
//                     View Order History
//                 </Link>
//             </div>
//         </div>
//     );
// };

// export default Thanks;

import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

function Thanks() {
  const navigate = useNavigate();

  // ✅ Get booking from sessionStorage
  const booking = JSON.parse(sessionStorage.getItem("lastBooking"));

  useEffect(() => {
    if (!booking) return;

    const WHATSAPP_NUMBER = "447405264139"; // no +

    const message = `
📢 *New Service Booking*

👤 Name: ${booking.firstName} ${booking.lastName}
📞 Phone: ${booking.phone}
📧 Email: ${booking.email}

🛠 Service: ${booking.service}
📍 Area: ${booking.area}
🏠 Address: ${booking.address}

👨‍🔧 Provider: ${booking.provider}
📌 Map: ${booking.map || "N/A"}
`;

    const url = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
      message.trim()
    )}`;

    const timer = setTimeout(() => {
      window.open(url, "_blank");
    }, 500);

    return () => clearTimeout(timer);
  }, []);

  if (!booking) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center">
        <p className="text-gray-600 mb-4">No booking found.</p>
        <button
          onClick={() => navigate("/")}
          className="bg-red-600 text-white px-6 py-2 rounded"
        >
          Go Home
        </button>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex flex-col items-center justify-center text-center p-4">
      <h1 className="text-3xl font-bold text-green-600">
        ✅ Booking Confirmed
      </h1>

      <p className="mt-3 text-gray-600">
        WhatsApp opened with your booking details.
      </p>

      <p className="text-sm text-gray-500 mb-6">
        Please press <strong>Send</strong> in WhatsApp.
      </p>

      {/* ✅ View Order History */}
      <button
        onClick={() => navigate("/OrderHistory")}
        className="bg-[#FF0000] text-white px-6 py-2 rounded hover:bg-red-700 transition"
      >
        View Order History
      </button>
    </div>
  );
}

export default Thanks;
